export const getUserDisplayName = (user = {}) => {
  const fullName = typeof user.fullname === "string" ? user.fullname.trim() : "";
  if (fullName) return fullName;

  const parts = [user.first_name, user.last_name]
    .filter((part) => typeof part === "string" && part.trim())
    .map((part) => part.trim());
  if (parts.length) return parts.join(" ");

  const email = typeof user.email === "string" ? user.email.trim() : "";
  return email || "Usuario";
};

export const getUserInitial = (user = {}) => {
  return getUserDisplayName(user).charAt(0).toUpperCase();
};
